module.exports = __webpack_public_path__ + "img/hill@2x.1c080ae9.png";